<template>
    <svg :height="height" :width="width" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 24 24">
        <defs>
            <clipPath id="clip-Arrow_Down">
                <rect width="24" height="24"/>
            </clipPath>
        </defs>
        <g id="Arrow_Down" fill="blue" clip-path="url(#clip-Arrow_Down)">
            <rect width="24" height="24" fill="rgba(81,91,96,0)"/>
            <g id="Group_38" data-name="Group 38">
                <path id="Path_33" data-name="Path 33" d="M0,24H24V0H0Z" fill="#515b60" opacity="0"/>
                <path id="Path_34" data-name="Path 34" d="M7.41,8,12,12.58,16.59,8,18,9.41l-6,6-6-6Z" transform="translate(0 0.59)" class="svg-secondary-color"/>
            </g>
        </g>
    </svg>
</template>

<script>

export default {
    name: "arrowDownIcon",
    props: ['width', 'height'],
}
</script>




// WEBPACK FOOTER //
// src/common/components/svg/shared/arrowDownIcon.vue